"use strict";

// A few handy utilities for composing boolean functions. Primarily
// useful for more complex `required` conditions in mongoose schemas.

/**
 * Given a list of functions, returns a single function that returns true
 * if all of the given functions return true with the supplied arguments.
 *
 * @params {Array} fns a list of functions
 * @return {Function} => {Boolean}
 */
exports.and = function (fns) {
  return function () {
    for (var i = 0; i < fns.length; ++i) {
      if (!fns[i].apply(this, arguments)) {
        return false;
      }
    }
    return true;
  };
};

/**
 * Given a list of functions, returns a single function that returns true
 * if any of the given functions return true with the supplied arguments.
 *
 * @params {Array} fns a list of functions
 * @return {Function} => {Boolean}
 */
exports.or = function (fns) {
  return function () {
    for (var i = 0; i < fns.length; ++i) {
      if (fns[i].apply(this, arguments)) {
        return true;
      }
    }
    return false;
  };
};